module.exports = __webpack_public_path__ + "static/media/falometro_logo_preto_arial.8c488fe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Home/components/falometro_logo_preto_arial.svg
// module id = 83
// module chunks = 0